import React from 'react';
import { BaseBox } from '@docon/docon-ui-library';
import { Image } from 'shared';

function CovidBanner() {

  function handleClick() {
    window.open('https://docon.cc/covid-vaccination', '_blank');
  }

  return (
    <BaseBox p='12px' className='clickable'>
      <Image
        src='/images/coronavirus_banner-1x.png'
        alt='covid banner'
        width={'100%'} height={'100%'}
        onClick={handleClick}
      />
    </BaseBox>
  );
}

export default CovidBanner;